import { useEffect, useState } from "react";
import classApi from "../../api/classApi";
import { courseListSelect, gradeListSelect, STATUS } from "../../constant";
import ListStudentPopup from "../ListStudentPopup";
import { useGetAllSubject } from "../../hooks/query/useGetAllSubject";
import { formatData } from "../../common";

interface CreateClassPopupProps {
    onClose: () => void;
    open: boolean;
    onSuccess: () => void;
}

function CreateClassPopup(props: CreateClassPopupProps) {
    const { open, onClose, onSuccess } = props;
    // const [show, setShow] = useState(open);
    const [error, setError] = useState("");
    const [nameClass, setNameClass] = useState<string>("");
    const [course, setCourse] = useState<string>("");
    const [subject, setSubject] = useState<string>("");
    const [teacher, setTeacher] = useState<number>(0);
    const [grade, setGrade] = useState<number>(0);
    const [listTeacher, setListTeacher] = useState([]);
    const [listStudent, setListStudent] = useState<any[]>([]);
    const [openPopup, setOpenPopup] = useState(false);

    const { data: subjectData } = useGetAllSubject();
    const subjectList = formatData(subjectData || []);

    const handleGetInforClassByCourseCode = async (course: string) => {
        const res = await classApi.getInforByCourseCode(course)
        return res;
    }

    useEffect(() => {
        const fetchData = async () => {
            if (course) {
                const res = await handleGetInforClassByCourseCode(course);
                console.log("res", res);
                const { teachers } = res.data;
                console.log("teacher", teachers);
                // setListStudent(students);
                setListTeacher(teachers);
            }
        };

        fetchData();
    }, [course]);

    const handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            // setShow(false);
            setTimeout(onClose, 300);
        }
    };

    // if (!open && !show) return null; 
    if (!open) return null;

    const resetForm = () => {
        setNameClass("");
        setCourse("");
        setSubject("");
        setTeacher(0);
        setGrade(0);
        setListStudent([]);
        setError("");
    }

    // const handleSubmit = async () => {

    //     if (!nameClass) {
    //         setError("❌ Vui lòng nhập tên lớp");
    //         return;
    //     }
    //     if (!course) {
    //         setError("❌ Vui lòng chọn khóa học");
    //     }
    //     if (!subject) {
    //         setError("❌ Vui lòng chọn môn học");
    //     }
    //     if (!teacher) {
    //         setError("❌ Vui lòng chọn giáo viên");
    //     }
    //     if (!grade) {
    //         setError("❌ Vui lòng chọn lớp");
    //     }
    //     if (listStudent.length === 0) {
    //         setError("❌ Vui lòng thêm ít nhất 1 học sinh vào lớp");
    //     }

    //     const listStudentId = listStudent.map(student => {
    //         return student.studentId
    //     })
    //     const data = {
    //         title: nameClass,
    //         // startDate: "2024-09-01",
    //         // endDate: "2024-12-15",
    //         // price: 500000,
    //         courseCode: course,
    //         teacherId: teacher,
    //         studentIds: listStudentId,
    //         gradeLevel: grade,
    //         subjectCode: subject,
    //         price: 0
    //     }
    //     const res = await classApi.createClass(data);
    //     console.log("res", res);
    //     toast.success("Tạo lớp học thành công")
    //     setError("");
    //     setShow(false);
    //     onSuccess();
    //     setTimeout(onClose, 300);

    // };
    const handleSubmit = async () => {
        try {
            if (!nameClass) return setError("❌ Vui lòng nhập tên lớp");
            if (!course) return setError("❌ Vui lòng chọn khóa học");
            if (!subject) return setError("❌ Vui lòng chọn môn học");
            if (!teacher) return setError("❌ Vui lòng chọn giáo viên");
            if (!grade) return setError("❌ Vui lòng chọn lớp");
            if (listStudent.length === 0) return setError("❌ Vui lòng thêm ít nhất 1 học sinh");

            const listStudentId = listStudent.map(s => s.studentId);

            const data = {
                title: nameClass,
                courseCode: course,
                teacherId: teacher,
                studentIds: listStudentId,
                gradeLevel: grade,
                subjectCode: subject,
                price: 0
            };

            const res = await classApi.createClass(data);
            console.log("RES CREATE CLASS: ", res);
            // success
            if (res.statusCode === STATUS.SUCCESS || res.statusCode === 201) {
                resetForm();
                onSuccess();
            }
        } catch (err: any) {
            console.log("ERROR: ", err);
            // ❗ Backend trả 400 sẽ vào đây
            const message = err?.response?.data?.message || "❌ Có lỗi xảy ra";
            if (message.includes("not teach")) {
                setError("Giáo viên không dạy môn học đã chọn");
            } else {
                setError(message);
                onClose();
            }
        }
    };

    const handleChangeName = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNameClass(e.target.value);
    };

    const handleData = (data: any[]) => {
        // Gộp danh sách cũ và mới
        const combined = [...listStudent, ...data];

        // Lọc trùng theo id
        const uniqueData = Array.from(
            new Map(combined.map(item => [item.id, item])).values()
        );

        console.log("list unique..", uniqueData);
        setListStudent(uniqueData);
    };

    const handleClear = (clearId: number) => {
        const newData = listStudent.filter(student => student.id !== clearId);
        setListStudent(newData);
    }
    return (
        <>
            {openPopup && <ListStudentPopup onData={handleData} courseCode={course} openPopup={openPopup} onClose={() => setOpenPopup(false)} onCancel={() => setOpenPopup(false)} />}
            <div
                className="fixed top-0 right-0 bottom-0 left-0 bg-[rgba(0,0,0,0.5)] z-50 flex justify-center items-center transition-opacity duration-300"
                onClick={handleOverlayClick}
            // style={{ opacity: show ? 1 : 0 }}
            >
                <div
                    className={`relative w-full lg:w-[600px] lg:min-h-[300px] h-[96%] bg-white p-[10px] rounded-box flex items-center flex-col transform transition-all duration-300
                        }`}
                >
                    <h2 className="text-secondary font-bold text-[20px] mt-[20px]">
                        Tạo lớp học mới
                    </h2>
                    <div className="my-[20px] flex flex-col w-[90%] gap-[10px]">
                        <div className="mb-[10px] flex items-center justify-between">
                            <div className="lg:w-[48%]">
                                <label className="font-[600] inline-block mb-[6px]">Tên lớp học *</label>
                                <input name="nameClass" onChange={handleChangeName} value={nameClass} className="outline-none border border-[#e0e0e0] rounded-[4px] py-[4px] px-[8px] w-full h-[46px] focus:border-[#3498db] focus:ring-1 focus:ring-[#3498db] transition-all duration-200 pr-10" />
                            </div>
                            <div className="lg:w-[48%]">
                                <label className="font-[600] inline-block mb-[6px]">Khóa học *</label>
                                <select
                                    className="outline-none border border-[#e0e0e0] rounded-[4px] py-[4px] px-[8px] w-full h-[46px]"
                                    value={course}
                                    onChange={(e) => {
                                        setCourse(e.target.value);
                                        if (error) setError(""); // reset lỗi khi chọn môn học
                                    }}>
                                    <option value="">Chọn</option>
                                    {courseListSelect.map((course) => {
                                        return (
                                            <option key={course.value} value={course.value}>{course.label}</option>
                                        )
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className="mb-[10px] flex items-center justify-between">
                            <div className="lg:w-[48%]">
                                <label className="font-[600] inline-block mb-[6px]">Môn học *</label>
                                <select
                                    className="outline-none border border-[#e0e0e0] rounded-[4px] py-[4px] px-[8px] w-full h-[46px]"
                                    value={subject}
                                    onChange={(e) => {
                                        setSubject(e.target.value);
                                        if (error) setError(""); // reset lỗi khi chọn môn học
                                    }}>
                                    <option value="">Chọn</option>
                                    {subjectList.map((subject : any) => (
                                        <option key={subject.value} value={subject.value}>
                                            {subject.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="lg:w-[48%]">
                                <label className="font-[600] inline-block mb-[6px]">Giáo viên *</label>
                                <select
                                    disabled={!course}
                                    className={`outline-none border rounded-[4px] py-[4px] px-[8px] w-full h-[46px]
    ${!course ? "bg-gray-200 text-gray-500 cursor-not-allowed" : "bg-white cursor-pointer"}
  `} value={teacher}
                                    onChange={(e) => {
                                        if (!course) {
                                            setError("❌ Vui lòng chọn khóa học trước");
                                            return;
                                        }
                                        setTeacher(Number(e.target.value));
                                        setError("");
                                    }}>
                                    <option value="">Chọn</option>
                                    {listTeacher.length > 0 && listTeacher.map((teacher: any) => {
                                        return (
                                            <option value={teacher.id}>{teacher.staff.user.fullName}</option>
                                        )
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className="mb-[10px] flex items-start justify-between min-h-[200px]">
                            <div className="lg:w-[48%] h-full">
                                <label className="font-[600] inline-block mb-[6px]">Lớp *</label>
                                <select
                                    className="outline-none border border-[#e0e0e0] rounded-[4px] py-[4px] px-[8px] w-full h-[46px]"
                                    value={grade}
                                    onChange={(e) => {
                                        setGrade(Number(e.target.value));
                                        if (error) setError("");
                                    }}>
                                    <option value={0}>Chọn</option>
                                    {gradeListSelect.map((grade) => {
                                        return (
                                            <option value={grade.value}>{grade.label}</option>
                                        )
                                    })}
                                </select>
                            </div>
                            <div className="lg:w-[48%] h-full">
                                <label className="font-[600] inline-block mb-[6px]">Danh sách học sinh *</label>
                                <div className="flex flex-col rounded-[4px] w-full h-full border border-[#e0e0e0]">
                                    <div className="w-full flex flex-col border-r border-[#e0e0e0]">
                                        <button disabled={!course} onClick={() => {
                                            if (!course) {
                                                setError("❌ Vui lòng chọn khóa học trước");
                                                return;
                                            }
                                            setOpenPopup(true);
                                        }} className={`
    w-full flex justify-center items-center h-[40px] text-white rounded-tl-[4px] rounded-tr-[4px]
    ${!course
                                                ? "bg-gray-200 cursor-not-allowed"
                                                : "bg-secondary hover:opacity-90 cursor-pointer"}
  `}>Thêm</button>
                                    </div>
                                    <div className={`flex-1 flex flex-col pt-[8px] max-h-[140px] ${listStudent.length > 3 ? "overflow-y-scroll custom-scroll" : ""}`}>
                                        {listStudent.length > 0 && listStudent.map(student => (
                                            <>
                                                <p className="px-[8px] mt-[4px] hover:bg-gray-400 hover:text-white p-[4px] flex justify-between items-center" key={student.studentId}><span>{student.fullName}</span><i onClick={() => handleClear(student.id)} className="fa fa-times cursor-pointer"></i></p>
                                            </>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p className="text-red-500 text-center h-[10px] my-[10px]">{error}</p>
                        <button
                            onClick={handleSubmit}
                            className="bg-secondary opacity-100 text-white py-[10px] px-[20px] rounded-[6px] hover:opacity-90 transition"
                        >
                            Tạo lớp
                        </button>
                        <button
                            className="absolute top-[10px] right-[10px]"
                            // onClick={() => setShow(false)}
                            onClick={onClose}
                        >
                            <i className="fa-solid fa-close text-[22px] text-blue-500"></i>
                        </button>
                    </div>

                </div>
            </div >
        </>
    );
}

export default CreateClassPopup;
